export default "__VITE_ASSET__BnSAYVWc__"